/* eslint-disable */
import jwt_decode from "jwt-decode";
const ls = require('local-storage');

import * as types from './mutation-types';

export default {
  [types.LOGIN](state, { userToken, user }) {
    state.authenticated = true;
    if (user) {
      state.user = user;
    } else if (userToken) {
      const decoded = jwt_decode(userToken);
      state.user = decoded.user;
    }

    state.userToken = userToken;
    if (userToken) {
      ls.set('userToken', userToken);
    }
  },
  [types.LOGOUT](state) {
    state.authenticated = false;
    state.user = null;
    state.userToken = null;
    ls.remove('userToken');
  },
  [types.UPDATE_USER](state, user) {
    state.user = null;
    state.user = user;
  },
  SET_USER_PROFILE(state, profile) {
    state.userProfile = null;
    state.userProfile = profile;
  }
};
